let pending = null;
export function requestQcHomeView(view) {
  pending = view === 'overview' ? 'overview' : 'reports';
}
export function takeQcHomeView(isManager) {
  const requested = pending;
  pending = null;
  if (!requested) return null;
  return isManager ? requested : 'my-reports';
}
